import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDp_YnCOlXtBgSQyCpdKsP6bQywu5x5amI",
  authDomain: "xynth.com",
  projectId: "tradegpt-8280f",
  storageBucket: "tradegpt-8280f.firebasestorage.app",
  messagingSenderId: "471471526265",
  appId: "1:471471526265:web:b01b75f52ffaec16a09fa8",
  measurementId: "G-ET8EEJLTTB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
